import Controller from '@ember/controller';
import { inject as service } from '@ember/service';

export default class BusinessAddressController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
}
